// Campus photo for /colleges/brandeis-university: CC BY-SA 4.0, by Kenneth C. Zirkel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABrandeis_University_Shapiro_Campus_Center_Waltham_Massachusetts.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/brandeis-university/; credited under the photo.
const photo = {
    "slug": "brandeis-university",
    "alt": "The Shapiro Campus Center across a lawn at Brandeis University in Waltham, Massachusetts",
    "src": "/colleges/brandeis-university/campus-1600.webp",
    "srcSmall": "/colleges/brandeis-university/campus-800.webp",
    "srcMid": "/colleges/brandeis-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/brandeis-university/og.jpg",
    "title": "Brandeis University Shapiro Campus Center Waltham Massachusetts",
    "author": "Kenneth C. Zirkel",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABrandeis_University_Shapiro_Campus_Center_Waltham_Massachusetts.jpg",
    "read": "2026-10-01"
};

export default photo;
